import { render, staticRenderFns } from "./ArenaPointTypeForm.vue?vue&type=template&id=19f816a7"
import script from "./ArenaPointTypeForm.vue?vue&type=script&lang=js"
export * from "./ArenaPointTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports